// action type constants
export const SET_SIDEBAR = 'SET_SIDEBAR';
export const SET_TABINDEX = 'SET_TABINDEX';

// actionCreators
export const setSidebar = (payload) => ({ type: SET_SIDEBAR, payload });
export const setTabIndex = (payload) => ({ type: SET_TABINDEX, payload });

export const getSidebar = (state) => state.sidebar.open;
export const getTabIndex = (state) => state.sidebar.tabIndex;
export const getMode = (state) => state.sidebar.mode;

const initialState = {
  open: true,
  tabIndex: 0,
  mode: 'layers',
};

const setMode = (state, tabIndex) => {
  switch (tabIndex) {
    case 0:
      state.mode = 'layers';
      break;
    case 1:
      state.mode = 'plan';
      break;
    default:
      break;
  }
};

// reducer
export default (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_SIDEBAR:
      state.open = payload;
      return;
    case SET_TABINDEX:
      state.tabIndex = payload;
      setMode(state, payload);
      return;
    default:
      return state;
  }
};
